// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
type Prettify<T> = {
  [K in keyof T]: T[K];
} & {};

type AntdConfig = Prettify<{}


>;

export type RuntimeAntdConfig = (memo: AntdConfig) => AntdConfig;
